<template>

<div class="section-wrapper" :class="{'is-parent': parent}">

	<router-link :to="{name: to}" class="section" :class="{'is-active': active}">

		<app-icon :name="icon" class="section-icon" />

		<div class="section-text">{{ text }}</div>

		<div class="section-count" v-if="count">{{ count }}</div>

	</router-link>

	<div class="section-children" v-if="parent && active">

		<slot></slot>

	</div>

</div>

</template>

<script>

export default {

	props: ['icon', 'text', 'to', 'parent', 'count'],

	computed: {

		active: function() {

			return this.$route.name === this.to || this.$route.meta.parent === this.to

		}

	}

}

</script>

<style scoped>

.section-wrapper {
	margin-bottom: 10px;
}

.section {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.section-icon {
	width: 48px;
	height: 40px;
	line-height: 40px;
	font-size: 24px;
	line-height: 40px;
	border-radius: 4px 0px 0px 4px;
	text-align: center;
    color: #fff;
    flex-shrink: 1;
    background-color: var(--color-blue-light);
}

.section-wrapper.is-parent .section-icon {
	border-radius: 4px 0px 0px 0px;
}

.section-text {
	height: 40px;
    color: var(--color-grey-dark);
    font-size: 14px;
    line-height: 38px;
    border-radius: 0px 4px 4px 0px;
    padding: 0px 10px;
    font-weight: 400;
    flex-grow: 1;
	border: 1px solid var(--color-grey-light);
	border-left-width: 0px;
	transition: all 100ms linear;
}

.is-desktop .section:not(.is-active):hover .section-text {
	border-color: var(--color-blue-light);
}

.section.is-active .section-text {
    color: #fff;
    background-color: var(--color-blue-light);
    border-color: var(--color-blue-light);
    border-radius: 0px;
    font-weight: 700;
}

.is-desktop .section .section-text:after,
.is-tablet .section .section-text:after {
	content: ' ';
	position: absolute;
	right: 0px;
	top: -1px;
	border-style: solid;
	border-width: 20px 0 20px 8px;
	border-color: transparent transparent transparent var(--color-blue-light);
	transition: all 100ms linear;
	opacity: 0;
}

.is-desktop .section.is-active .section-text:after,
.is-tablet .section.is-active .section-text:after {
	opacity: 1;
	right: -9px;
}

.section-children {
	border: 1px solid var(--color-grey-light);
	border-top-width: 0px;
	border-radius: 0px 0px 4px 4px;
	padding: 5px 0px 5px 0px;
}

.section-count {
	background-color: var(--color-blue-light);
	height: 16px;
	color: #fff;
	position: absolute;
	right: 8px;
	top: 12px;
	font-size: 10px;
	line-height: 16px;
	padding: 0px 4px;
	font-weight: 400;
	border-radius: 4px;
	min-width: 16px;
	text-align: center;
}

.section.is-active .section-count {
	color: var(--color-blue-light);
	background-color: #fff;
}

</style>